import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation, useHistory } from 'react-router'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config

  const history = useHistory();

  return (





    <div onClick={() => { history.push(to) }}
      className='menu-item menu-link px-5 d-flex p-2' style={{ cursor: 'pointer' }}>
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon m-2'>
            <KTSVG path={icon} className='svg-icon-2'  />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-1', fontIcon)}></i>}

      <a className={`m-2 menu-title ${isActive ? 'text-light' : 'text-muted'}`} >
        <span className='menu-title m-1 fs-6'>{title}</span>
      </a>
    </div>
  )
}

export { AsideMenuItem }
